var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"generic-box"},[_c('div',{staticClass:"generic-box-content text-center"},[_c('div',{staticClass:"no-record-found"},[(_vm.showAvatar == 'true')?_c('i',{staticClass:"fal fa-frown no-record-icon"}):_vm._e(),_vm._v(" "),(_vm.message)?[_vm._v(_vm._s(_vm.message))]:[_vm._v("No eBook found")]],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }